export default "__VITE_ASSET__C_jwsvNe__"